import { useState } from 'react';

export const useUserSearch = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const searchUsers = async (query) => {
    if (query.length < 2) {
      setSearchResults([]);
      return;
    }

    setIsSearching(true);
    try {
      const response = await fetch(
          `/api/users/search?query=${encodeURIComponent(query)}`
      );
      if (!response.ok) throw new Error("Ошибка при загрузке пользователей");
      const data = await response.json();
      setSearchResults(data.content || []);
    } catch (error) {
      console.error("Error searching users:", error);
    } finally {
      setIsSearching(false);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    searchUsers(value);
  };

  const handleUserSelect = (user) => {
    setSearchQuery(`${user.firstName} ${user.lastName}`);
    setSelectedUserId(user.id);
    setSearchResults([]);
  };

  return {
    searchQuery,
    setSearchQuery,
    searchResults,
    isSearching,
    handleSearchChange,
    handleUserSelect,
    selectedUserId,
    setSelectedUserId
  };
};